/* tslint:disable */
 
import { CollectionValueModel } from './collection-value-model';
import { NullableReferenceProperty } from './nullable-reference-property';
import { ReferenceProperty } from './reference-property';

/**
 * (tsType: Omit<UserStateDataEntryValue, 'user' | 'firstLogin'>, schemaOptions: { title: undefined, exclude: [ 'user', 'firstLogin' ] })
 */
export class UserStateDataEntryValueExcludingUserFirstLogin {
  dateFormat?: null | CollectionValueModel;
  dateTimeFormat?: null | CollectionValueModel;
  fontSize?: number;
  language?: ReferenceProperty;
  layoutMode?: string;
  menuMode?: string;
  theme?: null | NullableReferenceProperty;
  timeFormat?: null | CollectionValueModel;
  timeZone?: null | NullableReferenceProperty;
}
